import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
export default class DeleteGorbeaSeasonDataModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "seasons", []);
    _defineProperty(this, "selectedSeasonId", 0);
    _defineProperty(this, "confirmText", '');
    _defineProperty(this, "deleting", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.seasons = this.attrs.seasons || [];
    if (this.seasons.length > 0) {
      this.selectedSeasonId = parseInt(this.seasons[0].id());
    }
  }
  className() {
    return 'DeleteGorbeaSeasonDataModal Modal--medium';
  }
  title() {
    return 'Eliminar Datos de Temporada - Pastor del Gorbea';
  }
  onsubmit(e) {
    e.preventDefault();
    this.deleteData();
  }
  deleteData() {
    if (this.confirmText.trim().toUpperCase() !== 'ELIMINAR') {
      return;
    }
    this.deleting = true;
    m.redraw();
    app.request({
      method: 'DELETE',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/gorbea-season-data',
      params: {
        season_id: this.selectedSeasonId
      }
    }).then(() => {
      this.deleting = false;
      app.alerts.show({
        type: 'success'
      }, 'Todos los datos de Pastor del Gorbea para la temporada seleccionada han sido eliminados.');
      this.hide();
      if (this.attrs.onDeleted) {
        this.attrs.onDeleted();
      }
    }).catch(err => {
      this.deleting = false;
      console.error(err);
      app.alerts.show({
        type: 'error'
      }, 'Ha ocurrido un error al intentar eliminar los datos.');
      m.redraw();
    });
  }
  content() {
    const selectedSeason = this.seasons.find(s => parseInt(s.id()) === this.selectedSeasonId);
    const seasonName = selectedSeason ? selectedSeason.name() : '';
    return m("div", {
      className: "Form"
    }, m("div", {
      className: "Modal-body"
    }, m("div", {
      style: "background: rgba(244, 67, 54, 0.08); border: 1px solid rgba(244, 67, 54, 0.2); border-radius: 8px; padding: 15px; margin-bottom: 20px; color: #ff8a80; font-size: 0.95em; line-height: 1.5;"
    }, m("i", {
      className: "fas fa-exclamation-triangle",
      style: "margin-right: 8px;"
    }), m("strong", null, "\xA1ADVERTENCIA DE PELIGRO!"), " Esta acci\xF3n es irreversible. Se eliminar\xE1n permanentemente los siguientes datos para la temporada seleccionada:", m("ul", {
      style: "margin: 8px 0 0 20px; padding: 0; list-style-type: disc;"
    }, m("li", null, "Todas las votaciones de los foreros"), m("li", null, "Todas las puntuaciones finales calculadas"), m("li", null, "La ficha/registro de resultados oficiales de la temporada"))), m("div", {
      className: "Form-group"
    }, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 8px; color: var(--muted-color);"
    }, "Seleccionar Temporada a Eliminar"), m("select", {
      className: "FormControl",
      value: this.selectedSeasonId,
      onchange: e => {
        this.selectedSeasonId = parseInt(e.target.value);
        m.redraw();
      },
      disabled: this.deleting,
      style: "border-radius: 8px;"
    }, this.seasons.map(s => m("option", {
      value: s.id()
    }, s.name())))), m("div", {
      className: "Form-group",
      style: "margin-top: 20px;"
    }, m("label", {
      style: "font-weight: bold; display: block; margin-bottom: 8px; color: var(--muted-color);"
    }, "Escribe ", m("strong", {
      style: "color: var(--primary-color);"
    }, "ELIMINAR"), " para confirmar:"), m("input", {
      type: "text",
      className: "FormControl",
      value: this.confirmText,
      oninput: e => {
        this.confirmText = e.target.value;
        m.redraw();
      },
      placeholder: "ELIMINAR",
      disabled: this.deleting,
      style: "border-radius: 8px;"
    }))), m("div", {
      className: "Modal-footer",
      style: "display: flex; gap: 10px; justify-content: flex-end;"
    }, m(Button, {
      className: "Button",
      onclick: () => this.hide(),
      disabled: this.deleting,
      style: "border-radius: 8px;"
    }, "Cancelar"), m(Button, {
      className: "Button Button--primary",
      onclick: this.deleteData.bind(this),
      loading: this.deleting,
      disabled: this.confirmText.trim().toUpperCase() !== 'ELIMINAR',
      style: "background-color: #d32f2f; border-color: #d32f2f; border-radius: 8px; font-weight: bold; color: white;"
    }, m("i", {
      className: "fas fa-trash-alt",
      style: "margin-right: 6px;"
    }), " Eliminar Datos Definitivamente")));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/gorbea/DeleteGorbeaSeasonDataModal', DeleteGorbeaSeasonDataModal);